import '@fontsource-variable/geist';
import '@fontsource-variable/inter';
import './styles/main.css';
import './styles/precision.migration.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router/index.js';
import { armNotificationSound } from './utils/notificationSound.js';
import { initializeTheme } from './utils/theme.js';

initializeTheme();

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
armNotificationSound();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', async () => {
    const registration = await navigator.serviceWorker.register('/service-worker.js?v=8', { updateViaCache: 'none' });
    await registration.update();
  });
}
